import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import axiosIntance from '../../../helper/axios';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom"
import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import { baseUrl } from '../../../config';
import DatePicker from "react-datepicker";
import moment from 'moment'

import "react-datepicker/dist/react-datepicker.css";
import { clickColor, inArray } from './../../../library/util';

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';



import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import AddIcon from '@mui/icons-material/Add';
import objAdvancedFilter from '../../../library/advancedFilterLibFn';
import CloseIcon from '@mui/icons-material/Close';
const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: 'white'
  }),
  option: (styles, { isFocused, isSelected }) => ({
    ...styles,
    background: isFocused
      ? 'lightblue'
      : isSelected
        ? '#2a7bc0'
        : undefined,
    zIndex: 1
  }),
  menu: base => ({
    ...base,
    zIndex: 100
  })
}
const style_advanced = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};



const AddIconClasses = { color: '#337ab7', fontSize: '30px', marginLeft: '128px', marginTop: "-15px", cursor: 'pointer' };

const styleCloseIcon = {
  margin: '-27px'
}




function Csnoteswithoutcodes() {
  const history = useHistory();
  const [selectedRow, setSelectedRow] = useState(null);
  const { type } = useParams();
  let midTitle = '';


  const reportName = `Customer Service Notes Without Codes Report`
  const [startDate, setStartDate] = useState(new Date(Date.now() - 6 * 24 * 60 * 60 * 1000))
  const [endDate, setEndDate] = useState(new Date(Date.now() - 864e5).setHours(23, 59, 0, 0));
  const [selectedrowList, setSelectedRowList] = useState([]);


  /************* Advanced Filter ***********/
  const [group, setgroup] = useState('');


  const [groupC, setgroupC] = useState('');

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const selectInputRef = useRef();
  const selectInputRefInputFilter = useRef();




  const [filterValueC, setFilterValueC] = useState('')
  const [filterArrayC, setFilterArrayC] = useState([]);

  const [selectLabelHeaderC, setSelectLabelHeaderC] = useState([]);

  const loadFilterLabelC = (inputValue) => {
    let tempCategory = selectLabelHeaderC;
    return new Promise((resolve) => {
      resolve(tempCategory.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      ))
    });
  }


  const handleChangeFilterC = (e) => {
    if (e.target.value != undefined) {
      setFilterValueC(e.target.value);
    }
  }




  const addFilterC = () => {
    if (groupC != '' && filterValueC != '') {
      let tempObj = { field: groupC, value: filterValueC };
      filterArrayC.push(tempObj);
      setFilterArrayC(filterArrayC);
      setFilterValueC('')
    }
  }



  const deleteAdvancedFilterCFn = (item, index) => {
    const arr = filterArrayC.filter((item, j) => j != index);
    setFilterArrayC(arr);
  }




  const handleChangeC = (target) => {
    if (target != undefined) {
      setgroupC(target.value);
    }
  }
  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const setRowBackground = (selectedRow) => {
    if (inArray(selectedRow.tableData.id, selectedrowList) == false) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }


  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/');
  }

  checkUserTypeFn(history);

  function checkUserTypeFn(history) {
    const userdata = JSON.parse(localStorage.getItem('userdata'));
    const usertype = userdata.type;
    console.log('in check usertype fn');
    console.log(usertype)
    if (usertype != 'admin' && usertype != 'superadmin' && usertype != 'subadmin' && usertype != 'user' && usertype != 'owneradmin') {
      history.push('/');
    }
  }

  const [reportData, setReportData] = useState([])
  const [loader, setLoader] = useState(false)

  const [message, setMessage] = useState('')
  const data = [['attribute', 'attribute2'], ['value1', 'value2']];
  const [successMsg, setSuccessMsg] = useState('')
  useEffect(() => {
    setSelectLabelHeaderC(objAdvancedFilter.getFilterColumns('csnotes'))
    return () => {
      console.log('un subscribe')
      ResetFilter();
    }



  }, [midTitle])

  const ResetFilter = () => {
    setMessage('')
    setEndDate(new Date(Date.now()))
    setStartDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
    setReportData([]);
  }

  const fetchApi = () => {
    let filterStringC = '';
    filterArrayC.forEach((i, j) => {
      filterStringC += `C.${i.field}=${i.value}*`
    })
    if (startDate == null) {
      setMessage('Date must not be blank')
      return false;
    } else {
      setMessage('')
    }
    setLoader(true)

    axiosIntance.get(baseUrl + `/reports/csnoteswithoutcodes?startdate=` + moment(startDate).format('YYYY-MM-DD HH:mm:ss') + "&enddate=" + moment(endDate).format('YYYY-MM-DD HH:mm:ss') + "&filterStringC=" + filterStringC, {}).then(response => {

      if (response.data.result.length > 0) {
        console.log('data we have')
        response.data.result.forEach((i, j) => {
          console.log(i);
          i.decline_percent = roundToTwo(i.decline_percent * 100) + "%";
        });
        setReportData(response.data.result);

        console.log(response.data.result)
        setLoader(false)
        //setSuccessMsg('Data')
      } else {
        setLoader(false)
        setReportData([]);
        //setMessage('No data');
        console.log(45)
        // history.push('/home');
      }

    }).catch(error => {
      setLoader(false)
      setMessage('Something went wrong');
    });
  }

  const fetchApiDownload = () => {
    let filterStringC = '';
    filterArrayC.forEach((i, j) => {
      filterStringC += `C.${i.field}=${i.value}*`
    })
    const token = window.localStorage.getItem('token');
    window.location.href = baseUrl + `/reports/csnoteswithoutcodes/download?startdate=` + moment(startDate).format('YYYY-MM-DD HH:mm:ss') + "&enddate=" + moment(endDate).format('YYYY-MM-DD HH:mm:ss') + "&filterStringC=" + filterStringC+"&token="+token;

  }

  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }


  return (

    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />



      <div></div>
      <div></div>
      <div></div>
      <div></div>

      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>







      <section id="content-wrapper">
        <div classname="advancedFilterSection">
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style_advanced}>
              <label>CSNOTES Header</label>
              <label className='filterValueStyle'>Filter Values</label>
              <div class="input-bar">

                <div className="input-bar-item width100">

                  <AsyncSelect
                    ref={selectInputRef}
                    components={animatedComponents}
                    onChange={e => handleChangeC(e)}
                    cacheOptions
                    defaultOptions
                    maxMenuHeight={250}
                    className="widthSelectInput"
                    classNamePrefix="select"
                    styles={colourStyles}
                    getOptionLabel={(e) => e.label}
                    getOptionValue={(e) => e.value}
                    loadOptions={loadFilterLabelC}
                  />
                </div>

                <>

                  &nbsp;&nbsp;&nbsp;
                  <div className="input-bar-item width100">
                    <input type='text'
                      //  ref={selectInputRefInputFilter}
                      className='width140x filterValue'
                      placeholder="Value"
                      onChange={e => handleChangeFilterC(e)}
                    />
                    <AddIcon style={AddIconClasses} onClick={addFilterC} />
                  </div>
                  <div className="input-bar-item width100">
                    <div className="input-bar-item closeModel closeIconCommon">
                      <CloseIcon className='closeIcon' onClick={handleClose} />
                    </div>
                  </div>
                </>




              </div>

              <div className="input-bar-item width100">
                <div className="FilterSection">



                  {filterArrayC.map((item, index) => (
                    <>
                      <span className='filterCategory' id={index}>
                        <span className="filterSpan">{item.field} = {item.value}</span>
                        <CloseIcon onClick={(event) => deleteAdvancedFilterCFn(item, index)} className='closeIcon' />
                      </span>
                      <span className="whitespaceSpan">{'            '}</span>
                    </>
                  ))}
                </div>

              </div>




            </Box>
          </Modal>
        </div>

        <label>Start Date</label>
        <label className='endDateStyle'>End Date</label>
        <div className="input-bar">
          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={startDate}
              className='width140x'
              onChange={(date) => setStartDate(date)}
              placeholder='Start Date'

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}
            />

          </div>

          &nbsp;&nbsp;&nbsp;

          <div className="input-bar-item width100">

            <DatePicker
              dateFormat="yyyy-MM-dd HH:mm"
              selected={endDate}
              className='width140x'
              onChange={(date) => setEndDate(date)}
              placeholder='End Date'

              showTimeSelect
              timeFormat="p"
              timeIntervals={15}

            />

          </div>
          &nbsp;&nbsp;&nbsp;

          <div className="input-bar-item">
            <button type="button" onClick={handleOpen} className="btn btn-primary">Advanced Filter</button>
          </div>


          <div className="input-bar-item">
            <button type="button" onClick={fetchApi} className="btn btn-primary">Run Report</button>

          </div>
          <div className='input-bar-item'>
            <button type="button" onClick={ResetFilter} className="btn btn-primary">Reset</button>
          </div>

          {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

          <div className='downloadReportBtn'>
            {

              <button type="button" onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>

            }

          </div>
        </div>
        <div className="FilterSection">


          {filterArrayC.map((item, index) => (
            <>
              <span className='filterCategory' id={index}>
                <span className="filterSpan">{item.field} = {item.value}</span>
                <CloseIcon onClick={(event) => deleteAdvancedFilterCFn(item, index)} className='closeIcon' />
              </span>
              <span className="whitespaceSpan">{'            '}</span>
            </>
          ))}




        </div>

        {loader ?
          <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> :

          <MaterialTable
            // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

            onRowClick={((evt, selectedRow) =>
              setRowBackground(selectedRow)
            )}
            columns={[
              {
                title: "Note Left By", field: "note_left",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              },
              {
                title: "Count", field: "count",
                cellStyle: (e, rowdata) => {
                  if (rowdata.last == 1) {
                    return { fontWeight: 'bold' }
                  }
                }
              }

            ]}
            data={
              reportData
            }
            title={reportName}

            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              pageSize: 10,
              loadingType: 'linear',
              paging: false,
              exportButton: true,
              maxBodyHeight: '500px',
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
              })



            }}

          />
        }
      </section>

    </div>

  )
}

function roundToTwo(num) {
  return +(Math.round(num + "e+2") + "e-2");
}

export default Csnoteswithoutcodes
